import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '../theme';
import { isolateMixin, ifMobile } from '../utils/mixins';

var styles = function styles(theme) {
  return {
    success: {
      '& $message': {
        color: theme.colors.success
      }
    },
    warning: {
      '& $message': {
        color: theme.colors.warn
      }
    },
    error: {
      '& $message': {
        color: theme.colors.danger
      }
    },
    message: _extends({
      extend: isolateMixin,
      fontFamily: theme.fontFamily,
      marginTop: theme.inputStatus.marginTop,
      marginLeft: theme.inputStatus.marginLeft,
      fontWeight: theme.inputStatus.fontWeight,
      fontSize: theme.inputStatus.sizes.fontSize,
      lineHeight: theme.inputStatus.sizes.lineHeight + 'px',
      textAlign: 'left'
    }, ifMobile({
      marginTop: theme.inputStatus.mobile.marginTop,
      marginLeft: theme.inputStatus.mobile.marginLeft,
      fontSize: theme.inputStatus.sizes.mobile.fontSize,
      lineHeight: theme.inputStatus.sizes.mobile.lineHeight + 'px'
    }))
  };
};

var FieldStatus = /*#__PURE__*/function (_PureComponent) {
  _inherits(FieldStatus, _PureComponent);

  var _super = _createSuper(FieldStatus);

  function FieldStatus() {
    _classCallCheck(this, FieldStatus);

    return _super.apply(this, arguments);
  }

  _createClass(FieldStatus, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          theme = _this$props.theme,
          classes = _this$props.classes,
          message = _this$props.message,
          children = _this$props.children,
          rootClassName = _this$props.rootClassName,
          className = _this$props.className,
          containerRef = _this$props.containerRef,
          otherProps = _objectWithoutProperties(_this$props, ["type", "theme", "classes", "message", "children", "rootClassName", "className", "containerRef"]);

      var resultClassName = classnames(rootClassName, message && classes[type]);
      var messageResultClassName = classnames(classes.message, className);
      return React.createElement("div", _extends({
        className: resultClassName
      }, otherProps, {
        ref: containerRef
      }), children, message && React.createElement("div", {
        className: messageResultClassName
      }, message));
    }
  }]);

  return FieldStatus;
}(PureComponent);

FieldStatus.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Отображает текст статуса компонента input.
   * Тип предупреждения.
   */
  type: PropTypes.oneOf(['error', 'warning', 'success']),

  /**
   * Сообщение, которое будет отображаться как статус
   */
  message: PropTypes.node,

  /**
   * Элемент Input относительно которого будет отражаться FieldStatus
   */
  children: PropTypes.node.isRequired,

  /**
   * Дополнительный класс для контейнера
   */
  rootClassName: PropTypes.string,

  /**
   * Дополнительный класс для элемента сообщения
   */
  className: PropTypes.string,

  /**
   * Коллбек, принимающий ссылку на узел DOM
   */
  containerRef: PropTypes.func
} : {};
export default withStyles(styles, {
  name: 'FieldStatus'
})(FieldStatus);